import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ab6e4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tenvanban",
  style: {"font-weight":"bold","width":"50vw"}
}, "Tên đề tài :", -1))
const _hoisted_5 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Nội dung:", -1))
const _hoisted_7 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = {
  key: 0,
  class: "p-field p-col-6 p-md-6"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Tập tin đính kèm:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_panel = _resolveComponent("panel")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center"},
    header: "Nội dung văn bản"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              id: "tenvanban",
              type: "phone",
              modelValue: $setup.vanBan.tenVanBan,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.vanBan.tenVanBan) = $event)),
              style: {"width":"50vw"},
              readonly: ""
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createVNode(_component_Textarea, {
                id: "noidung",
                type: "phone",
                modelValue: $setup.vanBan.noiDungVanBan,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.vanBan.noiDungVanBan) = $event)),
                rows: "20",
                readonly: ""
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    ($setup.listFileName.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_DataTable, {
                            value: $setup.listFileName,
                            showGridlines: "",
                            style: {"font-size":"13px"},
                            class: "p-datatable-sm",
                            responsiveLayout: "scroll"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "nameFile",
                                header: "Tên"
                              }),
                              _createVNode(_component_Column, {
                                header: "",
                                style: {"width":"20px"}
                              }, {
                                body: _withCtx((slotProps) => [
                                  (slotProps.data.value)
                                    ? (_openBlock(), _createBlock(_component_Button, {
                                        key: 0,
                                        class: "p-button-raised p-button-secondary",
                                        label: "Tải",
                                        icon: "pi pi-download",
                                        onClick: ($event: any) => ($setup.downLoadFile(slotProps.data.value)),
                                        style: {"font-size":"13px"}
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _hoisted_12
        ])
      ])
    ]),
    _: 1
  }))
}